import { Card } from 'src/modules/shared/components/atoms/cards';
import { PiDotsNine } from 'react-icons/pi';
import { DraggableChildrenProps } from 'src/modules/shared/components/molecules/draggable-item';
import { classes } from 'src/modules/shared/utils/styles.util';

interface FunnelStatusCardProps {
  isHighlighted?: boolean;
  DragHandle?: DraggableChildrenProps['DragHandle'];
  children: React.ReactNode;
  className?: string;
  isAiLinked?: boolean;
}

export const FunnelStatusCard = ({
  isHighlighted = false,
  DragHandle,
  children,
  className = '',
  isAiLinked = false,
}: FunnelStatusCardProps) => {
  const containerClasses = classes(
    'h-full min-h-[150px] w-full transition-colors duration-150',
    className,
    isAiLinked && !isHighlighted
      ? 'bg-gradient-to-br from-primary-50/70 via-white to-white border !border-primary-200'
      : ''
  );

  const handleClasses =
    'cursor-grab hover:text-primary-500 flex items-center mr-2';

  return (
    <Card
      appearance="outline"
      variant="primary"
      className={containerClasses}
      isHighlighted={isHighlighted}
      shadow="none"
    >
      <div className="flex flex-col gap-4 h-full w-full">
        {DragHandle && (
          <DragHandle className={handleClasses}>
            <PiDotsNine className="h-5 w-5 text-primary-600" />
          </DragHandle>
        )}

        {children}
      </div>
    </Card>
  );
};
